<template>
  <section v-if="allLeagues.length" class="last-game-week-section">
    <h2>Dernière journée</h2>

    <div v-if="allLeagues.length > 1" class="league-picker">
      <label class="visually-hidden" for="last-game-week-league">Ligue</label>
      <select id="last-game-week-league" v-model="selectedLeagueId" class="form-select">
        <option v-for="league in allLeagues" :key="league.leagueId" :value="league.leagueId">
          {{ league.name }}
        </option>
      </select>
    </div>

    <template v-if="selectedLeague">
      <div class="league-header">
        <span class="league-logo" :style="{ backgroundImage: `url(${selectedLeague.imageUrl})` }" />
        <span class="league-name">{{ selectedLeague.name }}</span>
      </div>

      <best-team-display :league="selectedLeague" />
      <alternative-matches-display :league="selectedLeague" />
    </template>
  </section>
</template>

<script setup>
import { computed, ref, watch } from "vue";

import AlternativeMatchesDisplay from "@/components/alternativeMatches/AlternativeMatchesDisplay.vue";
import BestTeamDisplay from "@/components/bestTeam/BestTeamDisplay.vue";
import { useMPG } from "@/use/useMPG";

const { allLeagues } = useMPG();

const selectedLeagueId = ref(undefined);

const selectedLeague = computed(() => {
  return allLeagues.value.find(({ leagueId }) => leagueId === selectedLeagueId.value);
});

// Les ligues arrivent après le montage : on sélectionne la première dès
// qu'elles sont connues, et on retombe dessus si la ligue choisie disparaît
watch(allLeagues, (newLeagues) => {
  const isSelectionStillValid = newLeagues.some(({ leagueId }) => leagueId === selectedLeagueId.value);
  if (! isSelectionStillValid) {
    selectedLeagueId.value = newLeagues[0]?.leagueId;
  }
}, { immediate: true });
</script>

<style lang="scss" scoped>
.last-game-week-section {
  width: 95%;
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 0;

  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
}

.league-picker {
  margin-bottom: 20px;
}

.league-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;

  .league-logo {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-size: cover;
    background-position: center;
  }

  .league-name {
    font-size: 1.1rem;
    font-weight: 600;
  }
}
</style>